import React, {
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
} from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useTheme } from "styled-components";

const ConfirmContext = createContext(null);

const DEFAULTS = {
  title: "Confirmação",
  message: "",
  confirmText: "Confirmar",
  cancelText: "Cancelar",
  danger: false,
};

export function ConfirmProvider({ children }) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState(DEFAULTS);
  const resolverRef = useRef(null);

  const confirm = useCallback((opts = {}) => {
    setOptions({ ...DEFAULTS, ...opts });
    setOpen(true);
    return new Promise((resolve) => {
      resolverRef.current = resolve;
    });
  }, []);

  const close = useCallback((result) => {
    setOpen(false);
    if (resolverRef.current) {
      resolverRef.current(result);
      resolverRef.current = null;
    }
  }, []);

  const accentColor =
    theme?.name === "equi" ? "#2D68C4" : theme?.primary || "#3483fa";
  const confirmColor = options.danger ? "#e53935" : accentColor;

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <Modal
        isOpen={open}
        toggle={() => close(false)}
        centered
        contentClassName="border-0"
        style={{ borderRadius: 8 }}
      >
        <ModalHeader
          toggle={() => close(false)}
          style={{ borderBottom: "1px solid #eee", fontWeight: 600 }}
        >
          {options.title}
        </ModalHeader>
        <ModalBody style={{ fontSize: 14, color: "#333", whiteSpace: "pre-line" }}>
          {options.message}
        </ModalBody>
        <ModalFooter style={{ borderTop: "1px solid #eee" }}>
          <button
            type="button"
            onClick={() => close(false)}
            style={{
              padding: "10px 18px",
              borderRadius: 6,
              border: "none",
              background: "#ececec",
              color: "#333",
              fontWeight: 600,
              fontFamily: "'Montserrat', sans-serif",
              cursor: "pointer",
            }}
          >
            {options.cancelText}
          </button>
          <button
            type="button"
            onClick={() => close(true)}
            style={{
              padding: "10px 18px",
              borderRadius: 6,
              border: "none",
              background: confirmColor,
              color: "#fff",
              fontWeight: 600,
              fontFamily: "'Montserrat', sans-serif",
              cursor: "pointer",
            }}
          >
            {options.confirmText}
          </button>
        </ModalFooter>
      </Modal>
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) {
    throw new Error("useConfirm deve ser usado dentro de um ConfirmProvider");
  }
  return ctx;
}

export default ConfirmProvider;
